import {Alert, Button, Card, ListGroup, Modal, Stack} from "react-bootstrap";
import React, {FormEvent, Fragment, useState} from "react";
import {ContestSummaryResponse, joinContest} from "../../api/api";
import {useNavigate} from "react-router-dom";
import Form from "react-bootstrap/Form";

const JoinContestButton = ({contestId}: { contestId: string }) => {
  const [show, setShow] = useState(false);
  const [joining, setJoining] = React.useState(false);
  const navigate = useNavigate();
  const [error, setError] = React.useState<string | null>(null);
  const [name, setName] = React.useState<string>("");


  const handleClose = () => {
    setShow(false);
    setError(null);
    setJoining(false);
    setName("")
  };
  const handleShow = () => setShow(true);


  const handleJoin = (e: FormEvent) => {
    e.preventDefault();
    setJoining(true);
    setError(null);
    joinContest({id: contestId, name: name})
      .then(() => {
        setJoining(false);
        navigate(`/predictions/contests/${contestId}`);
      })
      .catch(() => {
        setError("Failed to join contest");
        setJoining(false);
      });
  }

  return (
    <Fragment>
      <Button variant="primary" onClick={handleShow}>
        Join
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Join Contest</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleJoin}>
          <Modal.Body>
            {error && <Alert variant={"warning"}>{error}</Alert>}
            <p>
              Enter your name to join the contest. This is the name that other participants in the contest will
              see.
            </p>
            <Form.Group className="mb-3" controlId="user.fullName">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            disabled={joining}
                            autoFocus={true}
                            required={true}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button type="submit" variant="primary" disabled={joining}>
              Join
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Fragment>
  );
};

export const ContestCard = ({contest}: { contest: ContestSummaryResponse }) => {


  return <Card key={contest.id} className={"mb-3"}>
    <Card.Body>
      <Card.Title>
        {contest.name}
      </Card.Title>
      {contest.description &&
        <Fragment>
          <Card.Text>{contest.description}</Card.Text>
        </Fragment>}
    </Card.Body>

    <ListGroup className="list-group-flush">
      <ListGroup.Item>{contest.predictionCount} predictions </ListGroup.Item>
    </ListGroup>
    <Card.Body>
      <Stack direction={"horizontal"} gap={3}>
        {contest.isParticipant ?
          <Fragment>
            {contest.isOpen ?
              <Button href={`/predictions/contests/${contest.id}`} className={'mr-5'}>Edit predictions</Button> :
              <Button href={`/predictions/contests/${contest.id}`} variant={"outline-primary"}
                      className={"mr-3"}>View predictions</Button>}
          </Fragment> :
          <Fragment>
            {contest.isOpen && <JoinContestButton contestId={contest.id}/>}
          </Fragment>
        }
      </Stack>
    </Card.Body>
  </Card>
}